import type { NewsItem, FeaturedExample, GalleryExample, TextExample } from "@/app/core/mainPage/prompt/shared/types";
export const ru = {
  settings: 'Настройки',
  theme: 'Тема',
  language: 'Язык',
  light: 'Светлая',
  dark: 'Тёмная',
  auto: 'Авто',
  russian: 'Русский',
  english: 'English',
  profile: 'Профиль',
  topUp: 'Пополнить',
  main: 'Главная',
  create: 'Создать',
  chats: 'Чаты',
  gallery: 'Галерея изображений',
  examples: 'Популярные примеры',
  tryThis: 'Попробуй это',
  startCreating: 'Начни создавать прямо сейчас',
  joinThousands: 'Присоединяйся к тысячам пользователей, которые уже создают контент с помощью ИИ',
  tryFree: 'Попробовать бесплатно',
  createWithAI: 'Создавай с помощью ИИ',
  generateTextsImages: 'Генерируй тексты, изображения и многое другое. Вдохновляйся примерами ниже или начните с собственной идеи.',
  viewAll: 'Смотреть все',
  universalChat: 'Универсальный чат',
  pinterest: 'Пинтрест',
  copyPrompt: 'Скопировать prompt',
  packages: 'Пакеты токенов',
  buy: 'Купить',
  compareFeatures: 'Сравнение возможностей',
  faq: 'Часто задаваемые вопросы',
  balance: 'Баланс',
  orderDetails: 'Детали заказа',
  tokenPackage: 'Пакет токенов',
  total: 'Итого',
  packageContents: 'Состав пакета',
  paymentMethod: 'Способ оплаты',
  telegramPayments: 'Telegram Payments',
  securePayment: 'Безопасная оплата через Telegram invoice.',
  pay: 'Оплатить',
  checkout: 'Оформление заказа',
  buyTokens: 'Купить токены',
  chooseTokenPackage: 'Выбери пакет токенов для пополнения баланса',
  saveMore: '💡 Экономь больше с крупными пакетами',
  bestValue: 'Лучшая цена',
  best: 'Best',
  tokens: 'токенов',
  pricePer100: 'за 100 токенов',
  noProducts: 'Пока нет товаров. Попробуй позже.',
  catalogUnavailable: 'Каталог временно недоступен: ',
  buyNow: 'Купить сейчас',
  inviteFriends: 'Пригласить друзей',
  inviteAndEarn: 'Приглашай и зарабатывай',
  friendDiscount: 'Твой друг получит скидку {discount}% на первую покупку',
  yourReferralLink: 'Твоя реферальная ссылка',
  copyLink: 'Копировать ссылку',
  copied: 'Скопировано!',
  recentInvites: 'Недавние приглашения',
  noInvites: 'Ты ещё никого не пригласил. Поделись ссылкой!',
  howItWorks: 'Как это работает?',
  step1: '1. Скопируй свою реферальную ссылку и отправь другу.',
  step2: '2. Друг регистрируется — ты становишься его реферером.',
  step3: '3. Друг получает скидку {discount}% на первую покупку подписки.',
  featuredExamplesTitle: 'Популярные примеры',
  galleryExamplesTitle: 'Галерея изображений',
  quickPromptsTitle: 'Попробуй это',
  tryThesePrompts: 'Попробуй эти запросы',
  copyPromptButton: 'Копировать prompt',
  promptPlaceholder: 'Например: "Составь план запуска продукта" или "Придумай визуальную концепцию для обложки"',
  shortcutHint: 'Ctrl/Cmd + Enter для быстрого запуска',
  textExamplesTitle: 'Примеры текстов',
  createChat: 'Создать чат',
  selectChatType: 'Выбери тип чата',
  newChat: 'Новый чат',
  newChatDescription: 'Начните новый запрос к ИИ',
  myChats: 'Мои чаты',
  myChatsDescription: 'История твои диалогов',
  soonMessage: 'Этот раздел скоро появится',
  soon: 'Скоро',
  close: 'Закрыть',
  back: "Назад",
  openSidebar: "Открыть список диалогов",
  selectModel: "Выбрать модель AI",
  aiAssistant: "AI-ассистент",
 welcomeTitle: "Начни с выбора модели",
  welcomeDescription: "Выбери модель, задай задачу и получи ответ с потоковой генерацией прямо в этом окне.",
  welcomeHistoryMessage: "История сообщений для выбранной беседы пока не загружается, но ты можете продолжить общение в ее текущем контексте.",
  example1: "Сформулируй план решения задачи",
  example2: "Помоги улучшить текст для клиента",
  example3: "Сделай короткое резюме документа",
  inputPlaceholder: "Введите сообщение...",
  generating: "Генерация ответа...",
  sendMessage: "Отправить сообщение",
  stopGeneration: "Остановить генерацию",
  copy: "Копировать",
  regenerate: "Регенерировать",
  tryAgain: "Попробовать снова",
  generationStopped: "Остановлено",
  generationError: "Не удалось завершить генерацию",
  dialogues: "Диалоги",
  newConversation: "Новый диалог",
  searchConversation: "Найти диалог...",
  noConversations: "Диалогов пока нет",
  noConversationsHint: "Начни новый диалог, и он появится в истории.",
  noSearchResults: "Ничего не найдено",
  noSearchResultsHint: "Попробуй изменить поисковый запрос.",
  selectModelTitle: "Выбор ИИ-модели",
  chatHistory: "История чатов" ,
  openChat: "Открыть чат",
  justNow: 'Только что',
  minAgo: 'мин назад',
  hourAgo: 'ч назад',
  yesterday: 'Вчера',
  daysAgo: 'дн назад',
  untitled: 'Без названия',
  chatExample1Title: 'Помощь с кодом Python',
  chatExample1Preview: 'Можешь помочь написать функцию для...',
  chatExample2Title: 'Идеи для статьи',
  chatExample2Preview: 'Нужны идеи для статьи про AI...',
  chatExample3Title: 'Перевод текста',
  chatExample3Preview: 'Переведи этот текст на английский...',
  fastStart: 'Быстрый старт в чате',
  suitableForDaily: 'Подходит для повседневных задач',
  qualityDependsOnPrompt: 'Качество зависит от формулировки промпта',
  dialogue: 'Диалог',
  textGeneration: 'Генерация текста',
  strongComplexInstructions: 'Сильна в сложных инструкциях',
  holdsLongContext: 'Хорошо держит длинный контекст',
  universalBalance: 'Универсальный баланс скорости и качества',
  codeAndAnalysis: 'Код и анализ',
  largeDocuments: 'Большие документы',
  fastAnswers: 'Быстрые ответы',
  contextStandard: 'Контекст: стандартный',
  showDetails: 'Показать детали',
  strengths: 'Сильные стороны',
  weaknesses: 'Слабые стороны',
  idealFor: 'Идеально подходит для:',
  stopped: 'Остановлено',
  gpt41Description: 'Самая мощная модель',
  gpt4oDescription: 'Быстрая и эффективная',
  claude3Description: 'Хорошо для длинных текстов',
  geminiDescription: 'От Google',
  myChatsDescriptionActive: 'История твоих диалогов',
  textModels: 'Текст',
  imageModels: 'Фото',
  videoModels: 'Видео',
  models: 'Модели',
  noModelsAvailable: 'Модели недоступны',
  proSettings: 'Pro генерация',
  proSettingsDescription: 'Здесь ты можешь настроить параметры генерации изображений и видео. Полноценные настройки появятся позже.',
  generate: 'Сгенерировать',
  newsTitle: 'Новости',
  topModels: "Топовые модели",
  addedDate: "Добавлено",
  tryModel: "Попробовать",
  wsReconnecting: "Переподключаем WebSocket...",
  wsError: "Соединение потеряно",
  wsRestored: "Подключение восстановлено",
  retry: "Повторить",
  yourOrder: "Ваш заказ",
  promoCode: "Промокод",
  enterPromoCode: "Введите промокод",
  apply: "Применить",
  promoApplied: "Промокод применен:",
  promoNotApplied: "Промокод не применен",
  subtotal: "Стоимость",
  referralDiscount: "Скидка по приглашению",
  promoDiscount: "Скидка по промокоду",
  toPay: "К оплате",
  delete: "Удалить",
  cancel: "Отмена",
  thinking: "Думаю...",
  callingLlm: "Вызываю LLM...",
  toolRunning: "Инструмент работает...",
  executingTools: "Выполняю инструменты...",
  processing: "Обрабатываю...",
  completed: "Завершено",
  running: "Выполняется...",
  promoEmpty: "Промокод пуст",
  promoSuccess: "Промокод успешно применен",
  promoAlreadyRedeemed: "Промокод уже был использован",
  promoError: "Ошибка применения промокода",
  aboutApp: "О приложении",
  termsOfUse: "Условия использования",
  privacyPolicy: "Политика конфиденциальности",
  support: "Поддержка",
  version: "Версия приложения",
  tokensUsedLabel: "Использовано токенов",
  tokensRemainingLabel: "Осталось токенов",
  calling_llm: "Вызываю LLM...",
  generating_image: "Генерация изображения",
  tool_running: "Выполняю инструмент",
  executing_tools: "Выполняю инструменты",
  yourReferralCode:"Твой рефиральный код",
  goodMorning:"Доброе утро",
  goodAfternoon:"Доброго дня",
  goodEvening:"Доброго вечера",
  goodNight:"Приятной ночи",
  welcomeTitle1: 'Добро пожаловать!',
  welcomeDesc1: 'Рады видеть вас в приложении. Готовы начать работу с нейросетями?',
  welcomeTitle2: 'Мощь ИИ в ваших руках',
  welcomeDesc2: 'Создавайте тексты, изображения и видео с помощью современных моделей.',
  welcomeTitle3: 'Вам подарок!',
  welcomeDesc3: 'Получите 100 приветственных токенов и протестируйте генерации прямо сейчас.',
  welcomeTitle4: 'С чего начнем?',
  welcomeDesc4: 'Выберите, что хотите сгенерировать в первую очередь.',
  welcomeText: 'Текст',
  welcomeTextDesc: 'Статьи, код, ответы',
  welcomeImage: 'Изображение',
  welcomeImageDesc: 'Арты, логотипы, фото',
  welcomeVideo: 'Видео',
  welcomeVideoDesc: 'Анимации и ролики',
  stepLabel: 'Шаг',
  agentThinking: 'Агент работает',
  toolsLabel: 'инстр.',
  phaseQueued: 'В очереди',
  phaseRunning: 'Выполняется',
  phaseFetching: 'Получение',
  phaseStoring: 'Сохранение',
  phaseCallingLlm: 'Обращение к модели',
  phaseExecutingTools: 'Выполнение инструментов',
  phaseGeneratingImage: 'Генерация изображения',
  phaseGeneratingVideo: 'Генерация видео',
  phaseGenerating: 'Генерация',
  phaseThinking: 'Размышление',
  consiliumLabel: 'Консилиум',
  imageModelLabel: 'Image AI',
  videoModelLabel: 'Video AI',
  searchToolLabel: 'Web Search',
  stepsLabel: 'Шаги',
  agentStarting: 'Запускаю…',
  noSteps: 'Нет данных',
  extractToolLabel: 'Чтение',
  agentAwaiting: 'Жду подтверждения',
  reasoning: 'Размышления',
  confirm: 'Подтвердить',
  reject: 'Отклонить',
  continue: 'Продолжить',

//новостной блок
newsItems: [
  {
    id: 'update-2.1',
    title: 'Обновление 2.1',
    summary: 'Добавлена поддержка GPT-4o и Claude 3.5 Sonnet, улучшена скорость генерации в 1.5 раза.',
    fullText: 'Мы рады представить обновление 2.1! В этой версии добавлена поддержка новейших моделей GPT-4o и Claude 3.5 Sonnet. Скорость генерации текста увеличена в 1.5 раза благодаря оптимизации WebSocket-соединений. Также исправлены ошибки в мобильной верстке и добавлены анимации перехода между вкладками.',
    imageUrl: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=600',
  },
  // другие новости
  ] as NewsItem[],
    noNews: 'Новостей пока нет.',
  featuredExamples: [
     {
      id: "feat-1",
      prompt: "Футуристический город на закате с летающими машинами и небоскребами",
      type: "image",
      imageUrl: "https://images.unsplash.com/photo-1759558909137-af1027a6a026?w=1080",
    },
    {
      id: "feat-2",
      prompt: "Напиши маркетинговую стратегию для запуска нового мобильного приложения",
      type: "text",
      result:
        "Для успешного запуска мобильного приложения необходим комплексный подход. Начните с pre-launch кампании за 2-3 месяца до релиза: создайте landing page, запустите сбор email подписчиков, активируйте социальные сети.",
    },



//галлерея
  ] as FeaturedExample[],
  galleryExamples: [
    { id: "img-1", prompt: "Абстрактная композиция в стиле Кандинского", imageUrl: "https://images.unsplash.com/photo-1741434056721-8e4e84f7aee3?w=1080", height: 400 },
    { id: "img-2", prompt: "Минималистичное рабочее пространство", imageUrl: "https://images.unsplash.com/photo-1772751541531-e084e8f56630?w=1080", height: 500 },
    { id: "img-3", prompt: "Горный пейзаж на рассвете", imageUrl: "https://images.unsplash.com/photo-1600257729950-13a634d32697?w=1080", height: 450 },
    { id: "img-4", prompt: "Современная архитектура", imageUrl: "https://images.unsplash.com/photo-1695067439031-f59068994fae?w=1080", height: 550 },
    { id: "img-5", prompt: "Красочный градиентный арт", imageUrl: "https://images.unsplash.com/photo-1665764884116-11bf71512155?w=1080", height: 400 },
    { id: "img-6", prompt: "Уютный интерьер", imageUrl: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400", height: 450 },
    { id: "img-7", prompt: "Ночной город", imageUrl: "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=400", height: 360 },
    { id: "img-8", prompt: "Космический пейзаж", imageUrl: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=400", height: 440},
    { id: "img-9", prompt: "Весенний сад", imageUrl: "https://images.unsplash.com/photo-1490750967868-88aa4a44a14a?w=400", height: 310},
  {
    id: "img-10",
    prompt: "Морской закат",
    imageUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400",
    height: 400,
  },
  {
    id: "img-11",
    prompt: "Портрет в стиле киберпанк",
    imageUrl: "https://images.unsplash.com/photo-1531746790095-8a5a5a5a5a5a?w=400",
    height: 500,
  },
  {
    id: "img-12",
    prompt: "Архитектура будущего",
    imageUrl: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=400",
    height: 420,
  },
  ] as GalleryExample[], //текстовые примеры
  textExamples: [
    {
      id: "text-1",
      prompt: "Составь резюме для позиции Senior Frontend Developer",
      preview:
        "ИВАН ПЕТРОВ\nSenior Frontend Developer\n\nОПЫТ РАБОТЫ:\n• Senior Frontend Developer, Tech Corp (2021-настоящее время)\n  - Руководство командой из 5 разработчиков",
    },
    {
      id: "text-2",
      prompt: "Напиши план статьи про искусственный интеллект в медицине",
      preview:
        "1. Введение: революция ИИ в здравоохранении\n2. Диагностика заболеваний с помощью машинного обучения\n3. Персонализированная медицина и прогнозирование",
    },
    {
      id: "text-3",
      prompt: "Создай описание продукта для маркетплейса",
      preview:
        "Беспроводные наушники Premium Sound Pro X\n\nПогрузитесь в мир кристально чистого звука с активным шумоподавлением нового поколения. 40 часов автономной работы.",
    },
    {
      id: "text-4",
      prompt: "Напиши письмо клиенту с извинениями за задержку",
      preview:
        "Уважаемый [Имя],\n\nПриносим искренние извинения за задержку с выполнением вашего заказа. Мы понимаем важность своевременной доставки и сожалеем о доставленных неудобствах.",
    },
  ] as TextExample[],
  //самые нижние примеры быстрые
  
  quickPrompts: [
    "Идеи для бизнеса",
    "План тренировок",
    "Рецепт ужина",
    "Email клиенту",
    "Пост для соцсетей",
    "Слоган для бренда",
    "Идея для подарка",
    "Список дел на неделю",
  ] as string[],

  //факью перевод
  faqItems: [
  {
    question: "Как купить токены?",
    answer: "Вы можете приобрести пакеты токенов в разделе «Пакеты токенов» вашего профиля. Выберите подходящий пакет и нажмите «Купить».",
  },
  {
    question: "Сгорают ли токены?",
    answer: "Нет, не сгорают. Те токены что вы купили остаются навсегда у вас.",
  },
  {
    question: "Какие получить бесплатные токены?",
    answer: "Каждый день, вам выдаются токены в зависимости от уровня лояльности, эти токены сгорают и начисляются ежедневно.",
  },
  {
    question: "Что даёт приоритетная поддержка?",
    answer: "Приоритетная поддержка означает ответ на ваши вопросы в течение 2 часов (в рабочее время) вместо стандартных 24 часов, а также доступ к персональному менеджеру.",
  },
] as { question: string; answer: string }[],
};